function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#j6ocq0xdda)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 29.333c-2.4 0-4.444-.844-6.133-2.533-1.69-1.689-2.534-3.733-2.534-6.133V19.9c-1.91-.311-3.5-1.205-4.766-2.683C3.3 15.739 2.667 14 2.667 12V4h4V2.667h2.666V8H6.667V6.667H5.333V12c0 1.467.523 2.722 1.567 3.767 1.044 1.044 2.3 1.566 3.767 1.566 1.466 0 2.722-.522 3.766-1.566C15.478 14.722 16 13.467 16 12V6.667h-1.333V8H12V2.667h2.667V4h4v8c0 2-.634 3.739-1.9 5.217C15.5 18.695 13.91 19.589 12 19.9v.767c0 1.666.583 3.083 1.75 4.25 1.167 1.166 2.583 1.75 4.25 1.75 1.667 0 3.083-.584 4.25-1.75 1.167-1.167 1.75-2.584 1.75-4.25v-2.234A3.878 3.878 0 0 1 22.083 17a3.874 3.874 0 0 1-.75-2.333c0-1.111.39-2.056 1.167-2.834.778-.777 1.722-1.166 2.833-1.166 1.111 0 2.056.389 2.834 1.166.777.778 1.166 1.723 1.166 2.834 0 .866-.25 1.644-.75 2.333a3.878 3.878 0 0 1-1.916 1.433v2.234c0 2.4-.845 4.444-2.534 6.133-1.689 1.689-3.733 2.533-6.133 2.533zM25.333 16c.378 0 .695-.128.95-.383a1.29 1.29 0 0 0 .384-.95 1.29 1.29 0 0 0-.384-.95 1.29 1.29 0 0 0-.95-.384 1.29 1.29 0 0 0-.95.384 1.29 1.29 0 0 0-.383.95c0 .377.128.694.383.95.256.255.573.383.95.383z"
}));

function SvgStethoscope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "j6ocq0xdda",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.b1caffaa.svg";
export { ForwardRef as ReactComponent };